var WeatherForecast = (function() {
  var tempLayer;
  var rainLayer;
  var windLayer;
  var weatherOptions;
  var weatherInfo;

  function setDates(dates) {
    var select = $('#ForecastDate');
    select.html('');
    $.each(dates, function (i, value) {
      select.append('<option value="' + value.Stamp + '">' + value.Local + '</option>');
    });
  }

  function updateWeatherInfo(success) {
    $.ajax({
        url: weatherOptions.weatherInfoUrl,
        contentType: 'application/json; charset=utf-8',
        type: 'GET',
        dataType: 'json'
      })
      .success(function(result) {
        weatherInfo = result;
        console.log(result);
        if (success) {
          success();
        }
      })
      .error(function(xhr, status) {
        console.log(status);
      });
  }

  function updateUrls() {
    var stamp = $('#ForecastDate').val();
    tempLayer.setUrl(weatherOptions.tempUrl + '&c=' + weatherInfo.C + '&t=' + stamp);
    rainLayer.setUrl(weatherOptions.rainUrl + '&c=' + weatherInfo.C + '&t=' + stamp);
    windLayer.setUrl(weatherOptions.windUrl + '&c=' + weatherInfo.C + '&t=' + stamp);
  }

  function showLegend(name) {
    if (name) {
        var widht = 10; //внешний отступ от края
        switch (name) {
            case "temp":
                //легенда для температуры
                widht += 400;  //размер легенды
                Legend.init(widht + 'px', "", name);
                widht += 2 * ( Legend.delta + 10); //размер легенды + два внутренних отступа + внешний отступ от края
                break;
            case "rain":
                //легенда для осадков
                widht += 400;   //размер легенды
                Legend.init(widht + 'px', "url('../Content/img/legend-rain.png')", name);
                widht += 2 * (Legend.delta + 10); //размер легенды + два внутренних отступа + внешний отступ от края
                break;
        }
        $('#weater-forecast-settings').css('right', widht + 'px').addClass("show");
    }
  }

  function hide() {
    $('#weater-forecast-settings').removeClass("show");
    Legend.hide();
  }

  function clearLayer() {
    hide();
  }

  function showLayer(name) {
    updateWeatherInfo(function () {

      if (name === 'Weather-Temp') {
        setDates(weatherInfo.TempDates);
        updateUrls();
        showLegend('temp');
        return;
      }
      if (name === 'Weather-Rain') {
        setDates(weatherInfo.RainDates);
        updateUrls();
        showLegend('rain');
        return;
      }
      if (name === 'Weather-Wind') {
        setDates(weatherInfo.WindDates);
        updateUrls();
        showLegend('wind');
        return;
      }
      
    });
  }

  function init(temp, rain, wind, options) {
    tempLayer = temp;
    rainLayer = rain;
    windLayer = wind;
    weatherOptions = {
      tempUrl: options.tempUrl,
      rainUrl:options.rainUrl,
      windUrl: options.windUrl,
      weatherInfoUrl: options.weatherInfoUrl
    };
    
    $('#ForecastDate').change(function() {
      console.log($(this).val());
      updateUrls();
    });

    updateWeatherInfo(function () {
      setDates(weatherInfo.TempDates);
      updateUrls();
    });
  }

  return {
    init: init,
    showLayer: showLayer,
    clearLayer: clearLayer,
    hide: hide,
    updateWeatherInfo: updateWeatherInfo
  };
}());
